module.exports = __webpack_public_path__ + "static/media/komma-rum.1f5ef0f3.png";